export const CHANGE_IS_LOADING = 'CHANGE_IS_LOADING'
export const SET_DATA = 'SET_DATA'
export const SHOW_CONTACT_FORM = 'SHOW_CONTACT_FORM'
export const SET_CONTACT_PERSON = 'SET_CONTACT_PERSON'
export const SET_GEO_DATA = 'SET_GEO_DATA'
